export default class PageResult<T>{
    items:Array<T>;
    totalCount:number;
}


// WEBPACK FOOTER //
// ./src/store/entities/page-result.ts